module.exports = __webpack_public_path__ + "static/media/tree_11.e6a55f99.JPG";